export const COMPANIES_URL = `v2/companies`;
export const COURSES_URL = `v2/courses`;
export const JOBS_URL = `v1/jobs`;
export const USERS_URL = `v1/users`;
export const DISCOUNTS_URL = `v2/discounts`;
export const ADMINS_URL = `v1/users/company`;
export const SKILLS_URL = `v1/skills`;
export const USERS_UPDATE_URL = `v1/auth/users`;
